module.exports = __webpack_public_path__ + "img/brillante_2.b4f0d925.svg";